import React from "react"
import { useWindowSize, useIsTop } from '../../../hooks'
import styled, { css } from 'styled-components'
import { useSpring, animated as a } from 'react-spring'

import Logo from './Logo'
import textSvg from '../../../images/english.svg'

const TextWrapper = styled(a.div)`
  ${({ theme: { breakpoints } }) => css`
    display: none;
    position: fixed;
    top: ${props => props.height - 28}px;
    transform-origin: top right;
    transform: rotateZ(90deg);
    right: 16px;
    @media (min-width: ${breakpoints.md}px) {
      display: block;
    }
  `}
`

const Text = styled.div`
  transform: rotateZ(180deg);
  width: 40vh;
  img {
    width: 100%;
    height: auto;
  }
`

const Frame = styled.div`
  ${({ theme: { breakpoints } }) => css`
    position: fixed;
    top: 8vh;
    right: 6vw;
    svg {
      height: 80vh;
    }
    @media (min-width: ${breakpoints.md}px) {
      top: 2vh;
      right: 20vw;
      svg {
        height: 96vh;
      }
    }
  `}
`

const FixedContents = () => {

  const size = useWindowSize()
  const isTop = useIsTop(200)

  const { filter, opacity } = useSpring({
    config: {
      tension: 80
    },
    filter: `blur(${isTop ? 0 : 30}px)`,
    opacity: isTop ? 1 : 0,
  })

  return (
    <>
      <Frame>
        <Logo isVisible={isTop} />
      </Frame>
      <TextWrapper height={size.height} style={{ filter, opacity }}>
        <Text>
          <img src={textSvg} alt="" />
        </Text>
      </TextWrapper>
    </>
    // </div>
  )
}

export default FixedContents